/* import __COLOCATED_TEMPLATE__ from './savings-and-folders-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();